import { render, staticRenderFns } from "./sureAAllocation.vue?vue&type=template&id=b24ca974&scoped=true"
import script from "./sureAAllocation.vue?vue&type=script&lang=js"
export * from "./sureAAllocation.vue?vue&type=script&lang=js"
import style0 from "./sureAAllocation.vue?vue&type=style&index=0&id=b24ca974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24ca974",
  null
  
)

export default component.exports